module.exports = __webpack_public_path__ + "static/07-80ce65f72893011628683d6197fb0dde.jpg";